import Cookies from "js-cookie";

export default function LogoutPage() {
  Cookies.remove("authToken");
  Cookies.remove("userData");
  window.location.href = "/home";
  return null;
}
